"use client";

import {
  ArrowsRightLeftIcon,
  BellAlertIcon,
  MusicalNoteIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";
import { HeartIcon } from "@heroicons/react/24/solid";
import { memo } from "react";
import { twMerge } from "tailwind-merge";

import { CategoryButton } from "@/components/selectArtistModal/categoryControl/CategoryButton";

function UnmemoizedCategoryControl({
  showMixedModelTab,
  className,
  namespace,
}: {
  namespace: string;
  showMixedModelTab: boolean;
  className: string;
}) {
  return (
    <ul
      className={twMerge(
        "flex flex-row flex-wrap items-center justify-center gap-x-4 gap-y-2",
        className
      )}
    >
      <CategoryButton
        namespace={namespace}
        text="Royalty-free Voices"
        value="Royalty-free"
        Icon={MusicalNoteIcon}
      />
      <CategoryButton
        namespace={namespace}
        text="Instruments"
        value="Instruments"
        Icon={BellAlertIcon}
      />
      <CategoryButton
        namespace={namespace}
        text="My Voices"
        value="My"
        Icon={UsersIcon}
      />
      {showMixedModelTab && (
        <CategoryButton
          namespace={namespace}
          text="Mixed Voices"
          value="Mixed"
          Icon={ArrowsRightLeftIcon}
        />
      )}
      <CategoryButton
        namespace={namespace}
        text="Favorites"
        value="Saved"
        Icon={HeartIcon}
      />
    </ul>
  );
}

export const CategoryControl = memo(UnmemoizedCategoryControl);
